import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { GreenFile } from "../../assets/svgs";
import { getSvgComponent } from "../../utils/svgUtils";
import "./styles.scss";

const RequeiredDocumentList = ({ documentList, hideToolTip = false }) => {
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { t } = useTranslation();

  return (
    <div className="required-document-card">
      {documentList &&
        documentList.map((document) => {
          return (
            <div
              className={`file-upload-card`}
              style={{
                border: "1px solid #e3e8ef",
              }}
            >
              <div className="left-section">
                <div className={"file-icon-box"}>
                  <img src={GreenFile} className="file-icon" alt="" />
                </div>

                <div className="file-info">
                  <div className="file-title-container">
                    <span className="file-title">
                      {t(`${routeName}.${document?.label}`)}
                    </span>
                    {document?.label_type && (
                      <span className="file-title-label">
                        {t(`${routeName}.${document?.label_type}`)}
                      </span>
                    )}
                    {!hideToolTip && document.rightIcon ? (
                      <>
                        <Tooltip
                          id="my-tooltip"
                          className="file-title-tooltip"
                        />
                        <img
                          src={getSvgComponent(document.rightIcon)}
                          alt="file title icon"
                          className="file-title-icon"
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content={t(
                            `${routeName}.${document?.toolTip}`
                          )}
                        />
                      </>
                    ) : null}
                  </div>
                  <span className="upload-size">
                    {t(`${routeName}.${document?.fileType}`)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default RequeiredDocumentList;
